import React from 'react'

export default () => <div><h2>Privacy Policy</h2></div>